import { render } from "./DateRangeFilter.vue?vue&type=template&id=2126e2d9"
import script from "./DateRangeFilter.vue?vue&type=script&lang=js"
export * from "./DateRangeFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__